module.exports = __webpack_public_path__ + "static/media/logo-white.286c521e.svg";